import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { PopoverInput } from './base/popover-input';

@Component({
    selector: 'popover-editable-textarea',
    template: require('./popover-textarea.template.html')
})
export class PopoverTextAreaComponent extends PopoverInput implements OnChanges {

	constructor() { super() }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['originalValue']) {
			this.dirtyValue = changes['originalValue'].currentValue;
        }
	}

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/editable-popover/popover-textarea.component.ts